/**
 * @generated SignedSource<<d8345dbad2bc96b556b4c5df0291e518>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "content"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "commentId",
        "variableName": "commentId"
      },
      {
        "kind": "Variable",
        "name": "content",
        "variableName": "content"
      }
    ],
    "concreteType": "UpdateCommentPayload",
    "kind": "LinkedField",
    "name": "updateComment",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsAuthentication",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ValidationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "MutationResult",
        "abstractKey": "__isMutationResult"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "comment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "content",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "404b97b08ac5b0a2d41486f9d24dcc48",
    "id": null,
    "metadata": {},
    "name": "UpdateCommentMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCommentMutation(\n  $commentId: ID!\n  $content: String!\n) {\n  updateComment(commentId: $commentId, content: $content) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n    comment {\n      id\n      content\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c8babb4b997a46218d4e5a3e21b3741d";

module.exports = node;
